module.exports = __webpack_public_path__ + "img/horizontal_7_4_5010.d6dc990b.png";